import { IVuexState } from "@/models/interfaces/store";

export function getInitialState<T>(): IVuexState<T> {
  return {
    data: null,
    status: {
      pending: false,
      success: false,
      fail: false,
      error: null
    }
  };
}

export function _mutationPending(state: any) {
  return {
    data: state.data,
    status: {
      success: false,
      fail: false,
      error: null,
      pending: true
    }
  };
}

export function _mutationSuccess<T>(data: T) {
  return {
    data,
    status: {
      pending: false,
      success: true,
      fail: false,
      error: null
    }
  };
}

export function _mutationFail<T>(error: T) {
  return {
    data: null,
    status: {
      pending: false,
      success: false,
      fail: true,
      error
    }
  };
}

export function updateState<T>(state: any, data: T | Error | null = null) {
  if (data === null) {
    // When request is pending
    return _mutationPending({ ...state });
  }

  // When request is success / fail
  return data instanceof Error ? _mutationFail(data) : _mutationSuccess(data);
}
